
/** This is a placeholder in the settings, which must be replaced with "2sxc" or another term for other dnn extensions */
export const ApiExtensionPlaceholder = 'e.x.t';

/** The special header meta tag containing settings for 2sxc */
export const MetaHeaderJsApi = '_jsApi';

/** The fallback path to the UI */
export const DnnUiRoot = '/desktopmodules/tosic_sexycontent/';

export const PlatformOqtane = 'oqtane';
export const PlatformDnn = 'dnn';

/** The fallback AntiForgery token header name (as in Dnn) */
export const AntiForgeryTokenHeaderNameDnn = 'RequestVerificationToken';
